import { c as _c } from "react/compiler-runtime";
import { $React } from '@legendapp/state/react-web';
import type { ButtonHTMLAttributes, ComponentProps, DetailedHTMLProps } from 'react';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
export type ChevronButtonProps = ComponentProps<typeof $React.button> & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  variant: 'prev' | 'next';
};
export function ChevronButton(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("btn btn-primary btn-inverse btn-circle size-11", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== variant) {
    t2 = variant === "prev" ? <PhosphorIcon className="text-[24px]" name="caret-left" /> : <PhosphorIcon className="text-[24px]" name="caret-right" />;
    $[7] = variant;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== props || $[11] !== t1 || $[12] !== t2) {
    t3 = <$React.button className={t1} {...props}>{t2}{children}</$React.button>;
    $[9] = children;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}